import { AppDataContext } from "../Providers/AppDataProvider";
import { useContext } from "react";

const useAppData = () => {
  return useContext(AppDataContext);
};

export { useAppData };
